// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96b71e95","455":"5bedd203","867":"50fb96be"}[chunkId] + ".chunk.js";
};